import React, { memo } from 'react';

import { Box, IconButton } from '@mui/material';
import { ArrowIcon } from '@sharedCR/coreDesignSystem/icons';
import { useOpenLoanApplicationFromChat } from 'app/shared/components/TeamChat/hooks';
import { getChannelDisplayName, getChannelId } from 'app/shared/components/TeamChat/TeamChat.utils';
import TeamChatChannel from 'app/shared/components/TeamChat/TeamChatChannel';
import TeamChatChannelTitle from 'app/shared/components/TeamChat/TeamChatChannelTitle';
import PropTypes from 'prop-types';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

import {
  channelViewHeaderStyles,
  channelViewStyles,
  channelViewTitleWrapperStyles,
} from './HeaderChatActiveChannelView.styles';
import { HeaderChatActiveChannelViewTestIds } from './HeaderChatActiveChannelView.testIds';

const HeaderChatActiveChannelView = memo(({ channel, currentUserId, onBack, onClose = null }) => {
  const chatId = getChannelId(channel);
  const fallbackName = getChannelDisplayName(channel) || 'Conversation';

  const { applicationId, onOpen } = useOpenLoanApplicationFromChat({
    chatId,
    onBeforeNavigate: onClose,
  });

  return (
    <Box sx={channelViewStyles}>
      <Box sx={channelViewHeaderStyles}>
        <IconButton
          aria-label="Back to inbox"
          data-testid={HeaderChatActiveChannelViewTestIds.BACK}
          size="small"
          onClick={onBack}
        >
          <ArrowIcon direction={IconDirection.LEFT} size={IconSize[20]} />
        </IconButton>
        <Box sx={channelViewTitleWrapperStyles}>
          <TeamChatChannelTitle
            channel={channel}
            fallbackName={fallbackName}
            onLoanNumberClick={applicationId ? onOpen : null}
          />
        </Box>
      </Box>
      <TeamChatChannel isHeaderHidden chatId={chatId} currentUserId={currentUserId} key={chatId} />
    </Box>
  );
});

HeaderChatActiveChannelView.propTypes = {
  channel: PropTypes.object.isRequired,
  currentUserId: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

export default HeaderChatActiveChannelView;
